import React from 'react';

import { InterventionPlanCategory } from 'utils/api/inbox';

import { StyledTab } from './styles';

interface Props {
  value: InterventionPlanCategory;
  text: string;
  activeCategory: InterventionPlanCategory;
  onClick: (category: InterventionPlanCategory) => void;
}

const PlanTab: React.FC<Props> = ({ value, text, activeCategory, onClick }) => (
  <StyledTab active={activeCategory === value} onClick={() => onClick(value)}>
    {text}
  </StyledTab>
);

export default PlanTab;
